import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import ApiService from "../services/api";
import { persistUserProfile } from "../helpers/userProfileStorage";
import { PATHS } from "../constants/paths";
import Loader from "../components/Loader/Loader";

const AvatarEnabledGuard = ({ children }) => {
  const [state, setState] = useState({ ready: false, enabled: false });

  useEffect(() => {
    let cancelled = false;
    ApiService.getStaffMeProfile()
      .then((res) => {
        if (cancelled) return;
        const profileData = res?.data?.data;
        const enabled = profileData?.avatarEnabled === true;
        if (profileData && typeof profileData.avatarEnabled === "boolean") {
          persistUserProfile(profileData);
        }
        setState({ ready: true, enabled });
      })
      .catch(() => {
        if (!cancelled) setState({ ready: true, enabled: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!state.ready) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 240,
        }}
      >
        <Loader width="50px" height="50px" />
      </div>
    );
  }

  if (!state.enabled) {
    return <Navigate to={PATHS.DOCTOR_DASHBOARD} replace />;
  }

  return children;
};

export default AvatarEnabledGuard;
